import React from 'react';
import { StorySection } from '../components/StorySection';
import { MusicIcon, WineIcon, CrownIcon, CloudIcon, UtensilsIcon, SparklesIcon, ShirtIcon, StarIcon, CarIcon } from 'lucide-react';
export function Experience() {
  return <main className="bg-matte" data-id="element-357">
      {/* Hero Banner */}
      <section className="relative h-[50vh] min-h-[400px] flex items-center justify-center overflow-hidden" data-id="element-358">
        <div className="absolute inset-0 z-0" style={{
        backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,0.4), rgba(0,0,0,0.9)), url('https://images.unsplash.com/photo-1574096079513-a8225ba06814?w=1920&q=80')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }} data-id="element-359" />
        <div className="relative z-10 text-center px-6 mt-16 fade-section" data-id="element-360">
          <h1 className="font-serif text-[50px] md:text-[62px] lg:text-[74px] text-white mb-6" data-id="element-361">
            THE EXPERIENCE
          </h1>
          <div className="w-24 h-px bg-gold mx-auto mb-6" data-id="element-362" />
          <p className="font-sans text-lg md:text-xl text-white/80 max-w-2xl mx-auto tracking-wide" data-id="element-363">
            From dinner to the dance floor — one seamless evening
          </p>
        </div>
      </section>

      {/* Section 1: The Evening Unfolds (Timeline) */}
      <section className="py-28 px-6 bg-matte fade-section" data-id="element-364">
        <div className="max-w-4xl mx-auto" data-id="element-365">
          <div className="text-center mb-20" data-id="element-366">
            <h2 className="font-sans text-sm tracking-mega-wide text-gold uppercase mb-4" data-id="element-367">
              The Journey
            </h2>
            <h3 className="font-serif text-[38px] md:text-[50px] text-white" data-id="element-368">
              THE EVENING UNFOLDS
            </h3>
          </div>

          <div className="relative border-l border-gold/30 ml-4 md:ml-1/2 md:left-1/2 md:-translate-x-1/2 space-y-16 md:space-y-24" data-id="element-369">
            {/* Step 1 */}
            <div className="relative pl-12 md:pl-0 md:flex md:items-center md:justify-between group" data-id="element-370">
              <div className="absolute left-[-17px] md:left-1/2 md:-translate-x-1/2 top-0 w-8 h-8 bg-matte border-2 border-gold rounded-full flex items-center justify-center z-10 group-hover:bg-gold transition-colors duration-300" data-id="element-371">
                <span className="font-serif text-sm text-gold group-hover:text-black" data-id="element-372">
                  1
                </span>
              </div>
              <div className="md:w-5/12 md:text-right md:pr-12" data-id="element-373">
                <h4 className="font-serif text-[26px] md:text-[32px] text-white mb-2" data-id="element-374">
                  The Welcome
                </h4>
                <span className="font-sans text-sm tracking-widest text-gold uppercase block mb-4" data-id="element-375">
                  6:00 PM - 8:00 PM
                </span>
              </div>
              <div className="md:w-5/12 md:pl-12" data-id="element-376">
                <p className="font-sans text-lg text-white/60 leading-relaxed" data-id="element-377">
                  Arrive, be seated, and explore the menu. Warm lighting and an
                  intimate atmosphere set the stage for the night ahead.
                </p>
              </div>
            </div>

            {/* Step 2 */}
            <div className="relative pl-12 md:pl-0 md:flex md:items-center md:justify-between md:flex-row-reverse group" data-id="element-378">
              <div className="absolute left-[-17px] md:left-1/2 md:-translate-x-1/2 top-0 w-8 h-8 bg-matte border-2 border-gold rounded-full flex items-center justify-center z-10 group-hover:bg-gold transition-colors duration-300" data-id="element-379">
                <span className="font-serif text-sm text-gold group-hover:text-black" data-id="element-380">
                  2
                </span>
              </div>
              <div className="md:w-5/12 md:text-left md:pl-12" data-id="element-381">
                <h4 className="font-serif text-[26px] md:text-[32px] text-white mb-2" data-id="element-382">
                  The Feast
                </h4>
                <span className="font-sans text-sm tracking-widest text-gold uppercase block mb-4" data-id="element-383">
                  8:00 PM - 10:00 PM
                </span>
              </div>
              <div className="md:w-5/12 md:text-right md:pr-12" data-id="element-384">
                <p className="font-sans text-lg text-white/60 leading-relaxed" data-id="element-385">
                  Savor authentic West African cuisine. From smoky Jollof to
                  perfectly spiced Suya, every dish tells a story of heritage
                  and flavor.
                </p>
              </div>
            </div>

            {/* Step 3 */}
            <div className="relative pl-12 md:pl-0 md:flex md:items-center md:justify-between group" data-id="element-386">
              <div className="absolute left-[-17px] md:left-1/2 md:-translate-x-1/2 top-0 w-8 h-8 bg-matte border-2 border-gold rounded-full flex items-center justify-center z-10 group-hover:bg-gold transition-colors duration-300" data-id="element-387">
                <span className="font-serif text-sm text-gold group-hover:text-black" data-id="element-388">
                  3
                </span>
              </div>
              <div className="md:w-5/12 md:text-right md:pr-12" data-id="element-389">
                <h4 className="font-serif text-[26px] md:text-[32px] text-white mb-2" data-id="element-390">
                  The Lounge
                </h4>
                <span className="font-sans text-sm tracking-widest text-gold uppercase block mb-4" data-id="element-391">
                  10:00 PM - 2:00 AM
                </span>
              </div>
              <div className="md:w-5/12 md:pl-12" data-id="element-392">
                <p className="font-sans text-lg text-white/60 leading-relaxed" data-id="element-393">
                  The lights dim, the DJ takes over. Afrobeats, premium
                  cocktails, and pure energy transform the space into a vibrant
                  nightlife destination.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2: The Lounge (Emphasis) */}
      <section className="py-28 px-0 bg-charcoal fade-section" data-id="element-394">
        <div className="grid grid-cols-1 md:grid-cols-5 min-h-[600px]" data-id="element-395">
          {/* Content Side (Left, 40%) */}
          <div className="md:col-span-2 bg-charcoal p-12 md:p-16 lg:p-24 flex flex-col justify-center order-2 md:order-1" data-id="element-396">
            <span className="font-sans text-sm tracking-mega-wide text-gold uppercase mb-2" data-id="element-397">
              After Dark
            </span>
            <h2 className="font-serif text-[38px] md:text-[50px] text-white mb-8" data-id="element-398">
              THE LOUNGE
            </h2>
            <p className="font-sans text-lg text-white/70 leading-relaxed mb-12" data-id="element-399">
              When dinner concludes, Tempoo truly comes alive. Our resident DJs
              spin the best of Afrobeats, Amapiano, and Hip-Hop every Friday and
              Saturday night. Experience premium bottle service, exclusive VIP
              sections, and an LED-lit ambiance that rivals the city's top
              clubs—all without leaving your seat.
            </p>

            {/* Mini Grid */}
            <div className="grid grid-cols-2 gap-8" data-id="element-400">
              <div className="flex items-start gap-4" data-id="element-401">
                <MusicIcon className="w-6 h-6 text-gold flex-shrink-0 mt-1" data-id="element-402" />
                <div data-id="element-403">
                  <h5 className="font-sans text-base text-white font-medium mb-1" data-id="element-404">
                    Live DJ
                  </h5>
                  <p className="font-sans text-sm text-white/50" data-id="element-405">
                    Afrobeats & Amapiano
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-406">
                <WineIcon className="w-6 h-6 text-gold flex-shrink-0 mt-1" data-id="element-407" />
                <div data-id="element-408">
                  <h5 className="font-sans text-base text-white font-medium mb-1" data-id="element-409">
                    Bottle Service
                  </h5>
                  <p className="font-sans text-sm text-white/50" data-id="element-410">
                    Premium spirits
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-411">
                <CrownIcon className="w-6 h-6 text-gold flex-shrink-0 mt-1" data-id="element-412" />
                <div data-id="element-413">
                  <h5 className="font-sans text-base text-white font-medium mb-1" data-id="element-414">
                    VIP Sections
                  </h5>
                  <p className="font-sans text-sm text-white/50" data-id="element-415">
                    Exclusive seating
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-416">
                <CloudIcon className="w-6 h-6 text-gold flex-shrink-0 mt-1" data-id="element-417" />
                <div data-id="element-418">
                  <h5 className="font-sans text-base text-white font-medium mb-1" data-id="element-419">
                    Hookah
                  </h5>
                  <p className="font-sans text-sm text-white/50" data-id="element-420">
                    Premium flavors
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Image Side (Right, 60%) */}
          <div className="md:col-span-3 h-[500px] md:h-auto relative order-1 md:order-2" data-id="element-421">
            <img src="https://images.unsplash.com/photo-1516997121675-4c2d1684aa3e?w=1200&q=80" alt="Tempoo Lounge Nightlife" className="w-full h-full object-cover" data-id="element-422" />
            <div className="absolute inset-0 bg-gradient-to-r from-charcoal via-transparent to-transparent hidden md:block" data-id="element-423" />
          </div>
        </div>
      </section>

      {/* Section 3: Floor Plan & Reservations */}
      <section className="py-28 px-6 bg-matte fade-section" data-id="element-424">
        <div className="max-w-7xl mx-auto" data-id="element-425">
          <div className="text-center mb-16" data-id="element-426">
            <h2 className="font-sans text-sm tracking-mega-wide text-gold uppercase mb-4" data-id="element-427">
              Choose Your Experience
            </h2>
            <h3 className="font-serif text-[38px] md:text-[50px] text-white" data-id="element-428">
              RESERVE YOUR SPOT
            </h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-429">
            {/* Card 1: Main Dining */}
            <div className="bg-charcoal border border-white/5 p-8 md:p-10 flex flex-col h-full group hover:border-white/20 transition-colors duration-300" data-id="element-430">
              <UtensilsIcon className="w-8 h-8 text-gold mb-6" data-id="element-431" />
              <h4 className="font-serif text-[26px] text-white mb-4" data-id="element-432">
                Main Dining
              </h4>
              <p className="font-sans text-lg text-white/60 mb-8 flex-grow" data-id="element-433">
                Intimate tables for 2-6 guests. Perfect for a dinner date or
                small gathering to enjoy our West African menu.
              </p>
              <div className="space-y-2 mb-8" data-id="element-434">
                <p className="font-sans text-sm text-white/80 flex justify-between border-b border-white/10 pb-2" data-id="element-435">
                  <span data-id="element-436">Capacity</span>
                  <span className="text-gold" data-id="element-437">Up to 6 guests</span>
                </p>
                <p className="font-sans text-sm text-white/80 flex justify-between pt-2" data-id="element-438">
                  <span data-id="element-439">Pricing</span>
                  <span className="text-gold" data-id="element-440">No minimum spend</span>
                </p>
              </div>
              <a href="tel:2405359729" className="w-full text-center border border-gold text-gold px-6 py-3 font-sans uppercase tracking-widest text-sm font-medium hover:bg-gold/10 transition-all duration-300" data-id="element-441">
                Reserve a Table
              </a>
            </div>

            {/* Card 2: VIP Booth */}
            <div className="bg-charcoal border border-gold/30 p-8 md:p-10 flex flex-col h-full relative overflow-hidden group hover:border-gold transition-colors duration-300" data-id="element-442">
              <div className="absolute top-0 right-0 bg-gold text-black font-sans text-xs uppercase tracking-widest px-4 py-1 font-bold" data-id="element-443">
                Popular
              </div>
              <CrownIcon className="w-8 h-8 text-gold mb-6" data-id="element-444" />
              <h4 className="font-serif text-[26px] text-white mb-4" data-id="element-445">
                VIP Booth
              </h4>
              <p className="font-sans text-lg text-white/60 mb-8 flex-grow" data-id="element-446">
                Premium booth seating with dedicated service. The best view of
                the lounge. Bottle packages available.
              </p>
              <div className="space-y-2 mb-8" data-id="element-447">
                <p className="font-sans text-sm text-white/80 flex justify-between border-b border-white/10 pb-2" data-id="element-448">
                  <span data-id="element-449">Capacity</span>
                  <span className="text-gold" data-id="element-450">Up to 10 guests</span>
                </p>
                <p className="font-sans text-sm text-white/80 flex justify-between pt-2" data-id="element-451">
                  <span data-id="element-452">Pricing</span>
                  <span className="text-gold" data-id="element-453">From $500 minimum</span>
                </p>
              </div>
              <a href="tel:2405359729" className="w-full text-center bg-gold/10 border border-gold text-gold px-6 py-3 font-sans uppercase tracking-widest text-sm font-medium hover:bg-gold hover:text-black transition-all duration-300" data-id="element-454">
                Book VIP
              </a>
            </div>

            {/* Card 3: Full Venue */}
            <div className="bg-charcoal border border-white/5 p-8 md:p-10 flex flex-col h-full group hover:border-white/20 transition-colors duration-300" data-id="element-455">
              <SparklesIcon className="w-8 h-8 text-gold mb-6" data-id="element-456" />
              <h4 className="font-serif text-[26px] text-white mb-4" data-id="element-457">
                Full Venue
              </h4>
              <p className="font-sans text-lg text-white/60 mb-8 flex-grow" data-id="element-458">
                Private buyout for corporate events, birthdays, and large
                celebrations. Custom menus and entertainment.
              </p>
              <div className="space-y-2 mb-8" data-id="element-459">
                <p className="font-sans text-sm text-white/80 flex justify-between border-b border-white/10 pb-2" data-id="element-460">
                  <span data-id="element-461">Capacity</span>
                  <span className="text-gold" data-id="element-462">Up to 150 guests</span>
                </p>
                <p className="font-sans text-sm text-white/80 flex justify-between pt-2" data-id="element-463">
                  <span data-id="element-464">Pricing</span>
                  <span className="text-gold" data-id="element-465">Custom pricing</span>
                </p>
              </div>
              <a href="tel:2405359729" className="w-full text-center border border-gold text-gold px-6 py-3 font-sans uppercase tracking-widest text-sm font-medium hover:bg-gold/10 transition-all duration-300" data-id="element-466">
                Inquire Now
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Section 4: What to Expect */}
      <section className="py-28 px-6 bg-charcoal fade-section" data-id="element-467">
        <div className="max-w-7xl mx-auto" data-id="element-468">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12" data-id="element-469">
            <div className="text-center flex flex-col items-center" data-id="element-470">
              <ShirtIcon className="w-10 h-10 text-gold mb-6" data-id="element-471" />
              <h4 className="font-serif text-[26px] text-white mb-4" data-id="element-472">
                Dress Code
              </h4>
              <p className="font-sans text-base text-white/60" data-id="element-473">
                Sophisticated attire. No athletic wear, hats, or work boots.
                Dress to impress.
              </p>
            </div>
            <div className="text-center flex flex-col items-center" data-id="element-474">
              <MusicIcon className="w-10 h-10 text-gold mb-6" data-id="element-475" />
              <h4 className="font-serif text-[26px] text-white mb-4" data-id="element-476">Music</h4>
              <p className="font-sans text-base text-white/60" data-id="element-477">
                Afrobeats, Amapiano, R&B, and Hip-Hop. Live DJ every Friday &
                Saturday night.
              </p>
            </div>
            <div className="text-center flex flex-col items-center" data-id="element-478">
              <StarIcon className="w-10 h-10 text-gold mb-6" data-id="element-479" />
              <h4 className="font-serif text-[26px] text-white mb-4" data-id="element-480">
                Service
              </h4>
              <p className="font-sans text-base text-white/60" data-id="element-481">
                Attentive, personalized service. Your server knows the West
                African menu inside out.
              </p>
            </div>
            <div className="text-center flex flex-col items-center" data-id="element-482">
              <CarIcon className="w-10 h-10 text-gold mb-6" data-id="element-483" />
              <h4 className="font-serif text-[26px] text-white mb-4" data-id="element-484">
                Parking
              </h4>
              <p className="font-sans text-base text-white/60" data-id="element-485">
                Free parking available in the plaza lot. Valet service available
                on weekends.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <StorySection data-id="element-486" />
    </main>;
}